import React from 'react'
import PropTypes from 'prop-types'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import {withRouter} from 'react-router'
import autobind from 'autobind-decorator'
import track from '../index'
import {setCrispData, crispHide} from '../crisp'
import get from 'lodash/get'

let lastRoute = ''

@withGraphQL(
  gql`
    query getMe {
      me {
        _id
        email
        name
        createdAt
        profile {
          fullName
          phone
          phoneVerified
          countryCode
        }
        verified
      }
    }
  `,
  {loading: null}
)
@withRouter
export default class Provider extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    children: PropTypes.object,
    me: PropTypes.object,
    loading: PropTypes.bool
  }

  componentDidMount() {
    this.updateUser({})
    this.interval = setInterval(this.checkRoute, 1000)
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  componentDidUpdate(prevProps, prevState) {
    this.updateUser(prevProps)
  }

  @autobind
  checkRoute() {
    const path = this.props.router.location.pathname
    if (lastRoute !== path) {
      lastRoute = path
      this.routeDidChange(path)
    }
  }

  routeDidChange(path) {
    track({action: 'page_view', userId: get(this.props.me, '_id', null), path: path})
  }

  stop() {
    this.isOn = false
  }

  start() {
    if (this.props.me) {
      setCrispData(this.props.me)
    }
    this.isOn = true
  }

  updateUser(prevProps) {
    if (this.props.loading) return

    if (
      this.props.router.location.pathname.startsWith('/exchange') ||
      this.props.router.location.pathname.startsWith('/admin')
    ) {
      if (this.isOn) {
        this.stop()
      }
      crispHide()
      return
    }

    if (prevProps.me) {
      if (!this.props.me) {
        // user logged out
        this.stop()
        this.start()
      }
    }

    if (!this.isOn) {
      this.start()
    }
  }

  render() {
    return this.props.children
  }
}



// WEBPACK FOOTER //
// ./src/App/helpers/track/Provider/index.js